<main>
    <div class="content">
        <div class="image-container">
            <img [src]="baseApiUrl + '/uploads/images/what_new/what_new/what_new_1.jpg'" alt="" class="main-image">
            <p class="image-text">{{ "what_new.Gallery" | translate }}</p>
        </div>
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a class="nav-link" href="/what-new/1">{{ "what_new.What's New" | translate }}</a>
                    </li>      
                    <li class="nav-item active">
                        <a class="nav-link" href="/gallery">{{ 'what_new.Gallery' | translate }}</a>
                    </li>     
                </ul>
            </div>
        </nav>
        <div class="gallery">
            <div class="button-tab">
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-1"></div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-5">
                        <button type="button" class="btn btn-primary mt-auto"><a href="gallery">{{ 'what_new.Images' | translate }}</a></button>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-4 col-5">
                        <button type="button" class="btn btn-primary active"><a href="gallery/video" class="active">{{ 'what_new.Videos' | translate }}</a></button>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-2 col-1"></div>
                </div>
            </div>
            <div class="container">
                <div class="row">

                    <div class="col-lg-6 col-md-6 col-sm-6 col-12 mb-3" *ngFor="let video of videoData">
                        <div class="video-container">
                            <iframe 
                                [src]="getSafeEmbedUrl(video.url)"
                                title="YouTube video player" 
                                frameborder="0" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                allowfullscreen>
                            </iframe>
                        </div>
                    </div>
                   
                </div>
            </div>            
        </div>
        <div class="bottom-content-poster">
            <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
            <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
        </div>
    </div>
</main>
